const currentUrl = window.location.origin;
export const dashboardRouteName = 'dashboard';
export const loginRouteName = 'login';
export const directLoginRouteName = 'direct.login';
export const registerRouteName = 'register';
export const passwordEmailRouteName = 'password.email';
export const verificationNoticeRouteName = 'verification.notice';
export const detailsRouteName = 'details';
export const emailUpdateRouteName = 'email.update';
export const emailChangeRouteName = 'email.change';
export const passwordResetRouteName = 'password.reset';
export const passwordChangeRouteName = 'password.change';
export const setupRouteName = 'setup';
export const noPermsName = 'noperms';
export const connectedChannelRouteName = 'connectedchannel';
export const coloursmasterdataRouteName = 'coloursmasterdata';
export const excludedPages = [
  'profile', 'legal', 'follower', 'billing', 'userProperties',
  detailsRouteName, dashboardRouteName,
];
export const bookingEngineRouteName = 'bookingengine';
export const channelsRouteName = 'channels';
export const distributionRouteName = 'distributors';
export const mappingMasterUrlKey = 'mappingmaster';
export const eHotelSuiteUrlKey = 'ehotel-suite';
export const hotelLinkageUrlKey = 'hotellinkage';
export const testPropertyGroup = 'test';
export const newPropertyGroup = 'new';
export const glovelerUrlKey = 'gloveler';

/**
 * According to the definitions here, we can add another project.
 * urlKey: The project URL key value.
 * If this key is detected in the URL, routePrefix variable adding as router prefix
 * So user will see pages according to routerPrefix added routes.
 * For mappingmaster local test, urlKey must be local.
 * @type {[{routePrefix: string, urlKey: string}]}
 */
const redirectConstants = [
  {
    urlKey: newPropertyGroup,
  },
  {
    urlKey: testPropertyGroup,
  },
  {
    urlKey: mappingMasterUrlKey,
  },
  {
    urlKey: eHotelSuiteUrlKey,
  },
  {
    urlKey: hotelLinkageUrlKey,
  },
  {
    urlKey: glovelerUrlKey,
  }];

export const redirectConstant = redirectConstants.find((item) => currentUrl.includes(item.urlKey));
